import React, { useState } from 'react';
import { useHasura } from 'context/ApiState';
import { ReactComponent as UserIcon } from 'assets/icons/icon-user.svg';
import SearchInput from 'components/SearchInput';
import Checkbox from 'components/Checkbox';

const OrgUsers = ({ organisation }) => {
  const [filter, setFilter] = useState('');
  const [pending] = useState([]);

  const {
    app_users,
    organisationUsers,
    removeOrganisationUser,
    addOrganisationUser,
  } = useHasura();

  return (
    <div className="card">
      <div className="cardBody">
        <aside>
          <h2 className="mb-4 text-lg text-gray-800">Associated Users</h2>
          <SearchInput
            placeholder="Filter"
            value={filter}
            onResetClick={() => setFilter('')}
            onChange={(event) => {
              setFilter(event.target.value);
            }}
          />
          <p className="mt-4 text-sm">
            Non-admin users that can access this Organisation. Changes are
            applied immediately.
          </p>
        </aside>
        <main>
          <div className="flex flex-wrap -m-1 wrapper-fixed-height">
            {app_users
              ?.filter(
                (user) =>
                  user?.id?.toLowerCase().includes(filter.toLowerCase()) &&
                  user?.is_admin === false,
              )
              ?.map((user) => {
                const checked = !!organisationUsers?.find(
                  (ou) =>
                    user?.id === ou?.user_id &&
                    organisation?.id === ou?.organisation_id,
                );

                return { ...user, checked };
              })
              // @ts-ignore
              ?.sort((a, b) => b.checked - a.checked)
              ?.map((user, i) => {
                const togglePermission = (event) => {
                  event.preventDefault();
                  pending[i] = true;
                  if (user.checked) {
                    // remove row from OrganisationUsers
                    confirm(
                      `Are you sure you want to revoke access to ${organisation?.name} for ${user?.id}`,
                    ) &&
                      removeOrganisationUser({
                        user_id: user?.id,
                        organisation_id: organisation?.id,
                      }).finally(() => {
                        pending[i] = false;
                      });
                  } else {
                    // add row to OrganisationUsers
                    confirm(
                      `Are you sure you want to grant access to ${organisation?.name} for ${user?.id}`,
                    ) &&
                      addOrganisationUser({
                        user_id: user?.id,
                        organisation_id: organisation?.id,
                      }).finally(() => {
                        pending[i] = false;
                      });
                  }
                  pending[i] = false;
                };

                return (
                  <div
                    key={i}
                    className={`w-full xl:w-1/2 border-4 border-white h-12 rounded-lg flex items-center cursor-pointer overflow-hidden
                  ${pending[i] ? 'text-gray-200 bg-white' : ''}
                  ${
                    pending[i]
                      ? 'text-gray-300 bg-gray-200'
                      : user.checked
                      ? 'text-red-500 bg-red-100'
                      : 'text-gray-500 bg-gray-100'
                  }`}
                    onClick={togglePermission}
                  >
                    <UserIcon className="flex-shrink-0 inline w-4 h-4 mx-3 pointer-events-none " />
                    <div className="flex flex-col flex-grow pr-1 overflow-x-hidden truncate pointer-events-none select-none">
                      <p className="text-xs font-semibold truncate">
                        {user?.id}
                      </p>
                    </div>
                    <Checkbox
                      checked={user.checked}
                      onChange={() => {}}
                      checkClassName="text-red-500"
                      className={user.checked ? 'bg-red-100' : 'bg-gray-200'}
                    />
                  </div>
                );
              })}
          </div>
        </main>
      </div>
    </div>
  );
};

export default OrgUsers;
